import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { siteInfo } from '@/mocks/site';

export default function HeroSection() {
  const featuredArticles = articles.filter((a) => a.isFeatured).slice(0, 3);
  const mainArticle = featuredArticles[0];

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Bold%20modern%20abstract%20geometric%20composition%20with%20warm%20orange%20coral%20and%20amber%20gradients%2C%20dynamic%20flowing%20shapes%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20clean%20editorial%20design%20feel%2C%20dark%20background%20with%20vibrant%20warm%20color%20bursts%2C%20professional%20news%20portal%20aesthetic&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="吃瓜群 - 吃瓜群众免费吃瓜与在线爆料大全"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="mx-auto max-w-7xl">
          <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-12">
            <div className="w-full lg:w-5/12 pt-16 md:pt-20">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
                吃瓜群众<br />
                <span className="italic text-primary-400">免费吃瓜</span>
                {' '}与{' '}
                <span className="italic text-accent-400">在线爆料</span>
                <br />大全
              </h1>
              <p className="mt-5 text-base md:text-lg text-background-300 leading-relaxed max-w-md">
                聚焦网红塌房、博主反差视频、明星聊天记录泄露等黑料大瓜，
                吃瓜群众聚集地，每日实时更新热门吃瓜事件。
              </p>
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mt-7">
                <a
                  href={`https://qm.qq.com/q/${siteInfo.qqGroupNumber}`}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="px-7 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer text-sm"
                >
                  加入QQ吃瓜群
                </a>
                <Link
                  to="/category/wanghong-tafang"
                  className="px-7 py-3 border border-background-300/50 text-background-50 font-medium rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer text-sm"
                >
                  浏览最新爆料
                </Link>
              </div>
            </div>

            <div className="w-full lg:w-7/12 mt-4 lg:mt-16">
              <Link
                to={`/article/${mainArticle.slug}`}
                className="block relative rounded-2xl overflow-hidden group cursor-pointer"
              >
                <div className="aspect-[16/10]">
                  <img
                    src={mainArticle.image}
                    alt={mainArticle.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full mb-3 whitespace-nowrap">
                    头条爆料
                  </span>
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-background-50 leading-snug line-clamp-2">
                    {mainArticle.title}
                  </h2>
                  <p className="mt-2 text-sm text-background-300 line-clamp-2 hidden sm:block">
                    {mainArticle.excerpt}
                  </p>
                  <div className="flex items-center gap-4 mt-3 text-xs text-background-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {(mainArticle.views / 10000).toFixed(1)}万
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {mainArticle.comments}
                    </span>
                    <span>{mainArticle.date}</span>
                  </div>
                </div>
              </Link>

              <div className="grid grid-cols-2 gap-3 mt-3">
                {featuredArticles.slice(1).map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="relative rounded-xl overflow-hidden group cursor-pointer aspect-[16/9]"
                  >
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-3">
                      <h3 className="text-sm md:text-base font-heading font-bold text-background-50 line-clamp-2">
                        {article.title}
                      </h3>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}